































exports.default =
  data: ->
    current_user: Session.current_user
    current_company: Session.current_company

  computed:
    show_company_management_menus: ->
       @current_user.isAdmin() || (!@current_user.requireEmailAuthorization() && !@current_user.isSeller() && !@current_user.isMonitoringManager())




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/configuration/sidebar.vue